import { useMemo, useRef } from 'react';
import { useLeftSidebarState, useLeftSidebarController } from '@atlassian/jira-layout-controller';
import type { UIControllerSubscriberProps } from './types';

export const UIControllerSubscriber = ({ children }: UIControllerSubscriberProps) => {
	const { collapseLeftSidebar, expandLeftSidebar } = useLeftSidebarController();
	const { isCollapsed, width } = useLeftSidebarState();

	const stateRef = useRef({
		state: {
			isCollapsed,
			isResizing: false,
			isResizeDisabled: false,
			productNavWidth: width,
		},
		collapse: collapseLeftSidebar,
		expand: expandLeftSidebar,
		toggleCollapse: () => (isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()),
	});

	const navigationUIController = useMemo(
		() => ({
			state: {
				isCollapsed,
				isResizing: false,
				isResizeDisabled: false,
				productNavWidth: width,
			},
			collapse: collapseLeftSidebar,
			expand: expandLeftSidebar,
			toggleCollapse: () => (isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()),
		}),
		[collapseLeftSidebar, expandLeftSidebar, isCollapsed, width],
	);

	stateRef.current = Object.assign(stateRef.current, navigationUIController);

	return children(stateRef.current);
};
